var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#money_svg__clip0_61530_7451)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.5h-21V18h21v-1.5zM22.5 19.5h-21V21h21v-1.5zM18 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM12 12a3 3 0 110-5.999A3 3 0 0112 12zm0-4.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM6 7.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15H3a1.504 1.504 0 01-1.5-1.5v-9A1.504 1.504 0 013 3h18a1.504 1.504 0 011.5 1.5v9A1.502 1.502 0 0121 15zm0-10.5H3v9h18v-9z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "money_svg__clip0_61530_7451"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMoney;